<template>
  <BbPopover
    v-model="showMenu"
    :hideCloseButton="true"
    location="bottom"
    contentClass="supported-languages"
    minWidth="300px"
    minHeight="400px"
  >
    <template #default>
      <BbBtn class="create-button" size="small" type="secondary">
        <template #prepend>
          <BbIcon size="small" name="plusincircle" />
        </template>
        <TextBody i18n-key="translation.newLanguage" />
      </BbBtn>
    </template>
    <template #popover>
      <div class="popover-container">
        <div class="search-container">
          <BbInput
            v-model="filterValue"
            class="search-input"
            size="small"
            :placeholder="t('common.search')"
            v-if="showMenu"
            autofocus
          >
            <template #prepend-inner>
              <BbIcon size="small" name="search" />
            </template>
          </BbInput>
        </div>
        <div class="languages-container">
          <div
            v-for="item in filteredLanguages"
            :key="item.language"
            class="language-name"
            @click="addLanguageColumn(item)"
          >
            {{ item.name }}
          </div>
        </div>
      </div>
    </template>
  </BbPopover>
</template>

<script>
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import TextBody from '~/components/common/TextBody';

export default {
  components: { TextBody },
  props: {
    supportedLanguages: {
      type: Array,
      default: () => [],
    },
  },

  setup(props, { emit }) {
    const { t } = useI18n();
    const showMenu = ref(false);
    const selectedLanguage = ref('');
    const filterValue = ref('');

    const filteredLanguages = computed(() =>
      props.supportedLanguages.filter((lang) => lang.name.toLowerCase().includes(filterValue.value.toLowerCase())),
    );

    const addLanguageColumn = (event) => {
      emit('change-language', event);
      selectedLanguage.value = '';
      showMenu.value = false;
      filterValue.value = '';
    };

    return {
      addLanguageColumn,
      filteredLanguages,
      filterValue,
      selectedLanguage,
      showMenu,
      t,
    };
  },
};
</script>

<style scoped lang="scss">
.popover-container {
  display: flex;
  flex-direction: column;

  .search-container {
    position: sticky;
    top: 0;
    z-index: 1;
  }

  .search-input {
    background: $bb-neutral-0;
  }

  .languages-container {
    display: flex;
    flex-direction: column;
    gap: $bb-spacing-3;
    padding: $bb-spacing-3 $bb-spacing-4 $bb-spacing-3 $bb-spacing-4;
    overflow-y: auto;
    flex: 1;

    .language-name {
      @include bb-regular-text-styles('lg');
      cursor: pointer;

      &:hover {
        color: $bb-primary-3;
        background-color: $bb-neutral-0;
      }
    }
  }
}
</style>
